import React from 'react'
import { CompanyRegistration } from '../pages/CompanyRegistration'
import { Home } from '../pages/Home'
import VerificationSuccess from '../pages/VerificationSuccess/VerificationSuccess'
import RestaurantMenu from '../pages/RestaurantMenu/RestaurantMenu'
import GuestPortalApp from '../pages/GuestPortal/GuestPortalApp'
import ForgotPassword from '../pages/auth/ForgotPassword'
import PasswordReset from '../pages/auth/PasswordReset'
import AllRestaurants from '../pages/AllRestaurants/AllRestaurants'
import OrderTracking from '../pages/OrderTracking/OrderTracking'

const PublicRoutes = [
    {
        path: '/',
        component: Home,
    },
    {
        path: '/home',
        component: Home,
    },
    {
        path: '/public',
        component: () => <div>Public Page</div>,
    },
    {
        path: '/company-registration',
        component: CompanyRegistration,
    },
    {
        path: '/email-verification',
        component: VerificationSuccess,
    },
    {
        path: '/verify-email',
        component: VerificationSuccess,
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/password-reset',
        component: PasswordReset,
    },
    {
        path: '/restaurant-menu',
        component: RestaurantMenu,
    },
    {
        path: '/guest',
        component: GuestPortalApp,
    },
    {
        path: '/guest/*',
        component: GuestPortalApp,
    },
    {
        path: '/restaurants',
        component: AllRestaurants,
    },
    {
        path: '/track-order/:orderId',
        component: OrderTracking,
    },
]

export default PublicRoutes 
